module.exports = __webpack_public_path__ + "static/media/contractOutgoing.0cf27eec.svg";